<section>
    <div class="container">
        <div class="row wrapper-row">
            <div class="col-md-4 col-heading">
                <div class="hr-line"></div>
                <div class="row h">
                    <h2 class="h-large col-auto">{{ 'hp.notice.lbl.001' | translate }}</h2>
                    <a class="simple-btn col-auto" routerLink="/serviceCenter/notice">
                        <span>{{ 'hp.notice.lbl.002' | translate }}</span>
                        <svg width="26" height="10" viewBox="0 0 26 10" fill="none">
                            <path d="M0 5H25" stroke="#2A2E46" />
                            <path d="M21 9L25 5L21 1" stroke="#2A2E46" stroke-miterlimit="10" />
                        </svg>
                    </a>
                </div>                
            </div>
            <div class="col-md col-notices">
                <div class="hr-line"></div>
                <ul>
                    <li class="row" *ngFor="let item of collection">
                        <a  (click)="handleOnClickBoardNo(item.boardNo)">
                            <div class="post-title row">
                                <h4 class="col h-false">{{item.title}}</h4>
                                <svg class="col-auto" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M1 1L6 6L1 11" stroke="#2A2E46" stroke-miterlimit="10" />
                                </svg>
                            </div>
                            <span class="post-date">{{ item.insDate }}</span>
                        </a>

                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>